module.exports = __webpack_public_path__ + "static/img/bg5.af1384e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg5.jpg
// module id = 01ec
// module chunks = 1